"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// scripts
require("./view");
require("./login-modal");
exports.default = angular.module('profumo.core.main', [
    'profumo.core.main.view',
    'profumo.core.main.login'
]);



//////////////////
// WEBPACK FOOTER
// ./scripts/core/main/index.ts
// module id = 447
// module chunks = 0